import { render, staticRenderFns } from "./halls-boothclaim.vue?vue&type=template&id=c6913fca&scoped=true"
import script from "./halls-boothclaim.vue?vue&type=script&lang=js"
export * from "./halls-boothclaim.vue?vue&type=script&lang=js"
import style0 from "./halls-boothclaim.vue?vue&type=style&index=0&id=c6913fca&prod&lang=scss"
import style1 from "./halls-boothclaim.vue?vue&type=style&index=1&id=c6913fca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6913fca",
  null
  
)

export default component.exports